<template>
  <div class="card bg-white border-0 rounded-3 mb-4">
    <div class="card-body p-4">
      <div class="default-table-area all-products">
        <div class="table-responsive">
          <table class="table align-middle">
            <thead>
            <tr>
              <th scope="col">Создано</th>
              <th scope="col">Комментарий</th>
              <th scope="col">Статус</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="item in list" :key="item.id">
              <td class="text-body">
                {{ formatDate(item.created_at) }}
              </td>
              <td class="text-body">
                {{ item.action }}
              </td>
              <td>
                  <span class="badge bg-primary bg-opacity-10 text-primary p-2 fs-12 fw-normal">
                    {{ item.details || 'Прочитано' }}
                  </span>
              </td>
            </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { fetchNots } from "@/api/notification";

export default {
  data() {
    return {
      list: [],
    };
  },
  methods: {
    async getList() {
      try {
        const data = await fetchNots();
        this.list = data.histories || [];
      } catch (error) {
        console.error("Error fetching notifications:", error);
        this.list = []; // Set list to empty array in case of error
      }
    },
    // Format date to relative time in Russian
    formatDate(dateString) {
      const date = new Date(dateString);
      const now = new Date();
      const diffInSeconds = Math.floor((now - date) / 1000);

      let result = '';
      if (diffInSeconds < 60) {
        result = `${diffInSeconds} секунд назад`;
      } else if (diffInSeconds < 3600) {
        result = `${Math.floor(diffInSeconds / 60)} минут назад`;
      } else if (diffInSeconds < 86400) {
        result = `${Math.floor(diffInSeconds / 3600)} часов назад`;
      } else {
        result = `${Math.floor(diffInSeconds / 86400)} дней назад`;
      }

      return result;
    },
  },
  mounted() {
    this.getList();
  },
};
</script>
